import qs, { ParsedQs } from 'qs';

export const parse = (value: string): ParsedQs =>
  qs.parse(value, { ignoreQueryPrefix: true });

export const stringify = (value: any): string =>
  qs.stringify(value, {
    strictNullHandling: true,
    encodeValuesOnly: true,
    allowDots: true,
  });
